// Static site content for My Eco Engineer

export const LENSES = [
  {
    slug: "decision-systems",
    index: "01",
    title: "Decision Systems",
    color: "#00E599",
    image: "https://images.unsplash.com/photo-1586165368502-1bad197a6461?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    short: "Frameworks for evaluating risk, prioritizing interventions, managing stress and cognitive load, and designing durable capacity systems.",
    long: "Decision Systems examines how people make decisions about chemical, material, and environmental exposures that may influence health over time, and how those decisions compound. It addresses risk evaluation, marketing literacy, uncertainty management, and the allocation of cognitive and operational capacity within households. Without sound decision systems, even accurate information can become overwhelming.",
  },
  {
    slug: "home-systems",
    index: "02",
    title: "Home Systems",
    color: "#FFB259",
    image: "https://images.unsplash.com/photo-1556117153-659e8ce704c1?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    short: "Indoor air, moisture control, building materials, furnishings, and household products that shape the baseline level of exposure within the residential environment.",
    long: "Home Systems examines the chemical and material environment inside the residential home. This includes indoor air, water, materials, moisture control, furnishings, and household products that shape the baseline exposure conditions of daily life.",
  },
  {
    slug: "body-inputs",
    index: "03",
    title: "Body Inputs",
    color: "#43C6F0",
    image: "https://images.unsplash.com/photo-1748543668751-902d6461890d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    short: "Personal care products, food storage, ingredient analysis, absorption pathways, and metabolic burden.",
    long: "Body Inputs focuses on direct inputs to the body through ingestion, inhalation, and absorption, and how repeated contact across personal care products, food storage, textiles, and other materials contributes to cumulative exposure.",
  },
  {
    slug: "beyond-the-home",
    index: "04",
    title: "Beyond the Home",
    color: "#B98CFF",
    image: "https://images.unsplash.com/photo-1512531123205-560f5974e686?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    short: "Workplaces, public spaces, travel environments, and exposures encountered outside the spaces you directly control.",
    long: "Beyond the Home examines exposures that arise from larger systems that individuals do not fully control. This includes workplaces, public spaces, infrastructure, supply chains, and other environments encountered outside the residential home.",
  },
];

export const lensBySlug = (slug) => LENSES.find((l) => l.slug === slug);
export const domainColor = (slug) => (LENSES.find((l) => l.slug === slug)?.color) || "#00E599";

export const PHILOSOPHY = [
  { k: "Systems over swaps", v: "Exposure patterns are system outcomes." },
  { k: "Cumulative load over isolated risk", v: "Exposure compounds across sources." },
  { k: "Prioritization over perfection", v: "Not all decisions carry equal weight." },
  { k: "Clarity over noise", v: "Information should simplify decisions, not multiply them." },
];

export const PROCESS = [
  { n: "01", t: "Map exposure pathways", d: "Identify where cumulative burden builds across domains." },
  { n: "02", t: "Assess relative impact", d: "Weigh meaningful risk instead of treating all risks equally." },
  { n: "03", t: "Account for cognitive load", d: "Ensure recommendations are practical, sustainable, and real-world." },
  { n: "04", t: "Translate to frameworks", d: "Produce clear decision frameworks and implementation pathways." },
];

export const CONTACT_REASONS = [
  "Coaching",
  "Household Systems Setup",
  "Media / Speaking",
  "Advisory Engagement",
  "Corporate Workshop",
  "Product Inquiry",
  "Partnership Inquiry",
  "Content / Research",
  "Feedback",
];

export const NAV = [
  { label: "Greenpapers", to: "/greenpapers" },
  { label: "Sample Library", to: "/sample-library", soon: true },
  { label: "Ecosystem", to: "/ecosystem" },
  { label: "Products", to: "/products" },
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];
